"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Provides functionality for performing GraphQL 'search' operations, including handling pagination.
 * This class is meant to be extended or used as a mixin; it's not meant to be used directly.
 * @template T The type of objects being requested.
 * @mixin
 */
var SearchQueryService = /** @class */ (function () {
    /**
     * Creates an instance of search query service.
     * @param {GraphQLClient} client that fetches data from a GraphQL endpoint.
     */
    function SearchQueryService(client) {
        this.client = client;
    }
    /**
     * 1. Validates mandatory search query arguments
     * 2. Executes search query with pagination
     * 3. Aggregates pagination results into a single result-set.
     * @template T The type of objects being requested.
     * @param {string | DocumentNode} query the search query.
     * @param {SearchQueryVariables} args search query arguments.
     * @returns {T[]} array of result objects.
     * @throws {RangeError} if a valid root item ID is not provided.
     * @throws {RangeError} if the provided language(s) is(are) not valid.
     */
    SearchQueryService.prototype.fetch = function (query, args) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var results, hasNext, after, fetchResponse;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!args.rootItemId) {
                            throw new RangeError('"rootItemId" and "language" must be non-empty strings');
                        }
                        if (!args.language) {
                            throw new RangeError('"rootItemId" and "language" must be non-empty strings');
                        }
                        results = [];
                        hasNext = true;
                        after = '';
                        _c.label = 1;
                    case 1:
                        if (!hasNext) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.client.request(query, __assign(__assign({}, args), { after: after }))];
                    case 2:
                        fetchResponse = _c.sent();
                        results = results.concat((_b = (_a = fetchResponse) === null || _a === void 0 ? void 0 : _a.search) === null || _b === void 0 ? void 0 : _b.results);
                        hasNext = fetchResponse.search.pageInfo.hasNext;
                        after = fetchResponse.search.pageInfo.endCursor;
                        return [3 /*break*/, 1];
                    case 3: return [2 /*return*/, results];
                }
            });
        });
    };
    return SearchQueryService;
}());
exports.SearchQueryService = SearchQueryService;
